import { render, staticRenderFns } from "./formProdutosRcvat.vue?vue&type=template&id=db72150e&scoped=true"
import script from "./formProdutosRcvat.vue?vue&type=script&lang=js"
export * from "./formProdutosRcvat.vue?vue&type=script&lang=js"
import style0 from "./formProdutosRcvat.vue?vue&type=style&index=0&id=db72150e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db72150e",
  null
  
)

export default component.exports